import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import ArrowDown from "rialto-icons/ArrowDown";
import ArrowUp from "rialto-icons/ArrowUp";

import styles from "./Proposal.css";

export default class Section extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: !!props.isOpen };

    this.handleToggleOpen = this.handleToggleOpen.bind(this);
  }

  handleToggleOpen() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  render() {
    const { isOpen } = this.state;
    const { children, title } = this.props;

    return (
      <div className={styles.section}>
        <div
          className={cx(styles.sectionTitle, styles.clickable, {
            [styles.closed]: !isOpen,
          })}
          onClick={this.handleToggleOpen}
        >
          {title}
          {isOpen ? <ArrowUp size="small" /> : <ArrowDown size="small" />}
        </div>
        {isOpen && children}
      </div>
    );
  }
}

Section.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element.isRequired,
    PropTypes.arrayOf(PropTypes.element.isRequired),
  ]),
  isOpen: PropTypes.bool,
  title: PropTypes.string.isRequired,
};
